import apiClient from './apiClient';

/**
 * Go-live migration endpoints (Settings → Migration): upload the operational
 * A26 Excel, review/correct the parsed data, then import it — dry run first.
 */

const handleError = (error) => {
  const message =
    error.response?.data?.error?.message ||
    error.response?.data?.message ||
    error.message ||
    'An unexpected error occurred';
  return new Error(message);
};

export const parseExcel = async (file, baseYear) => {
  try {
    const form = new FormData();
    form.append('file', file);
    if (baseYear) form.append('baseYear', String(baseYear));
    const response = await apiClient.post('/admin/migration/parse', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    });
    return response.data.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const importPayload = async (payload, { dryRun = true, billingMode = 'historic-all', importHours = true } = {}) => {
  try {
    const form = new FormData();
    form.append(
      'payload',
      new Blob([JSON.stringify(payload)], { type: 'application/json' }),
      'migration-payload.json'
    );
    form.append('dryRun', dryRun ? 'true' : 'false');
    form.append('billingMode', billingMode);
    form.append('importHours', importHours ? 'true' : 'false');
    const response = await apiClient.post('/admin/migration/import', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000,
    });
    return response.data.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const listBatches = async () => {
  try {
    const response = await apiClient.get('/admin/migration/batches');
    return response.data.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const downloadCsv = async (batchId, kind) => {
  try {
    const response = await apiClient.get(`/admin/migration/batches/${batchId}/csv`, {
      params: { kind },
      responseType: 'blob',
      timeout: 120000,
    });
    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `migration-${batchId}-${kind}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw handleError(error);
  }
};
